import { useAppSelector } from "../stores/Hooks";

export function useAuth(requiredRoles?: string[]) {
  const { isAuthenticated, permissions, userId, permissionsLoaded } = useAppSelector((state) => state.auth);
  const isLoading = isAuthenticated === null || (isAuthenticated === true && !permissionsLoaded);
  const granted = permissions ?? [];
  const hasRequiredRole = !requiredRoles || requiredRoles.some((role) => granted.includes(role));

  return { isAuthenticated, hasRequiredRole, isLoading, roles: granted, permissions, userId };
}
